/* Maison Sahari v3 — réactivité. Chargé AVANT maison-sahari.js (defer, ordre du document). */
(function () {
  'use strict';
  var html = document.documentElement;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var design = !!(window.Shopify && window.Shopify.designMode);

  /* Apparition au défilement : même effet que reveal() de maison-sahari.js, mais sans aucune lecture de
     mise en page (getBoundingClientRect) : l'IntersectionObserver donne l'état initial. Les éléments sont
     marqués .ms-io ici, donc reveal() d'origine les ignore. */
  var GROUPS = [['.ms-mani__inner', 0], ['.section-resource-list__header', 0], ['.section-resource-list .resource-list__item', 1], ['.ms-look__head', 0], ['.ms-look__tile', 1], ['.ms-jour__head', 0], ['.ms-jour__item', 1], ['.ms-jour__follow', 0], ['.ms-feat:not(.ms-feat--hero) .ms-feat__text', 0], ['.ms-val__col', 1], ['.ms-faq__head', 0], ['.ms-faq__list', 0], ['.ms-wait__inner', 0]];
  function reveal() {
    if (reduce || design || !('IntersectionObserver' in window)) return;
    var els = [];
    try {
      GROUPS.forEach(function (g) {
        var i = 0;
        document.querySelectorAll(g[0]).forEach(function (el) {
          if (el.classList.contains('ms-io')) return;
          el.classList.add('ms-io');
          if (g[1]) { el.style.setProperty('--ms-i', String(i % 4)); i += 1; }
          els.push(el);
        });
      });
      if (!els.length) return;
      var ready = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.bottom <= 0) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
        if (!ready) { ready = true; html.classList.add('ms-ready'); }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
      els.forEach(function (el) { io.observe(el); });
      document.addEventListener('focusin', function (e) {
        var b = e.target.closest && e.target.closest('.ms-io');
        if (b) b.classList.add('is-in');
      });
      window.addEventListener('beforeprint', function () { els.forEach(function (el) { el.classList.add('is-in'); }); });
      /* filet de sécurité : si l'observateur ne répond pas, rien ne reste caché */
      setTimeout(function () { if (!ready) els.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
    } catch (err) {
      html.classList.remove('ms-ready');
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();

  /* Images : décodage asynchrone partout (le LCP garde son attribut d'origine) */
  function decode() {
    document.querySelectorAll('img:not([decoding]):not([fetchpriority="high"])').forEach(function (img) { img.decoding = 'async'; });
  }
  if ('requestIdleCallback' in window) requestIdleCallback(decode, { timeout: 2500 }); else setTimeout(decode, 1500);
})();
